import config from './package.json';
import { ModuleConfig } from '../../types/configTypes';
import MyPrivilegesSaga from './sagas/myPrivilegesSaga';
import myPrivilegesCardViewRegistry from '../../registries/MyPrivilegesCardViewRegistry';
import RefractiveSurgeryMyPrivilegesCardView from './containers/MyPrivilegesCardView';
import RefractiveSurgeryMyPrivilegesDetailsView from './containers/MyPrivilegesDetailsView';

myPrivilegesCardViewRegistry.register(
  config.id,
  undefined,
  RefractiveSurgeryMyPrivilegesDetailsView,
  false,
  config.myPrivigesReducerSubName,
);
myPrivilegesCardViewRegistry.register(
  config.disabledId,
  undefined,
  RefractiveSurgeryMyPrivilegesDetailsView,
  true,
  config.myPrivigesReducerSubName,
);

export default {
  config,
  sagas: [MyPrivilegesSaga],
} as ModuleConfig;
